import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component, DestroyRef,
  EventEmitter, inject,
  Input,
  OnDestroy,
  OnInit,
  Output
} from "@angular/core";
import {takeUntil} from "rxjs";
import {UserNotificationService} from "./user-notification.service";
import {Subject} from "rxjs";
import {NotificationBodyType, UserNotification} from "./user-notification.models";
import {DomSanitizer} from "@angular/platform-browser";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
    selector: 'app-user-notifications',
    templateUrl: './user-notifications.component.html',
    styleUrls: ['./user-notifications.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UserNotificationsComponent implements OnInit{
  @Input() mobile: boolean;
  @Output() closeNotifications = new EventEmitter();

  public notifications: UserNotification[] = [];
  readonly NotificationBodyType = NotificationBodyType;
  isShowReadAll: boolean = false;
  private readonly destroyRef = inject(DestroyRef);

  constructor(private userNotificationService: UserNotificationService,
              private sanitizer: DomSanitizer,
              private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.getNotifications();
  }

  getNotifications() {
    this.userNotificationService.notificationData
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((list) => {
        this.notifications = list.map(n => ({
          ...n,
          safeBody: n.bodyType === NotificationBodyType.Html
            ? this.sanitizer.bypassSecurityTrustHtml(n.body)
            : n.body
        }));
        this.isShowReadAll = this.notifications.some(n => !n.isRead);
        this.cdr.markForCheck();
      }, error => {
      });
  }

  openNotification(notification: UserNotification) {
    if (!notification.isRead) {
      this.userNotificationService.setOutletMessagesIsRead([notification.outletMessageId])
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(res => {
          const foundNotification = this.notifications.find(n => n.outletMessageId === notification.outletMessageId);
          if (foundNotification) {
            foundNotification.isRead = true;
          }
          const newCount = this.notifications.filter(n => !n?.isRead)?.length;
          this.userNotificationService.newNotificationsCounter.next(newCount);
          this.userNotificationService.notificationData.next(this.notifications);
          this.cdr.markForCheck();
        })
    }
  }

  readAll(){
    const idx = this.notifications.filter(notif => !notif.isRead)
                                           .map(n => n.outletMessageId);
    this.userNotificationService.setOutletMessagesIsRead(idx)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(res => {
        this.notifications.forEach(item => item.isRead = true);
        this.userNotificationService.newNotificationsCounter.next(0);
        this.userNotificationService.notificationData.next(this.notifications);
        this.cdr.markForCheck();
      })
  }

  closeWidget() {
    this.closeNotifications.emit(true);
  }

  trackById(index: number, item: UserNotification) {
    return item.outletMessageId;
  }

}
